import { render, staticRenderFns } from "./ReceiveMoney.vue?vue&type=template&id=8d152014&scoped=true&"
import script from "./ReceiveMoney.vue?vue&type=script&lang=js&"
export * from "./ReceiveMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d152014",
  null
  
)

export default component.exports